<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-overlay :show="formLoader">
                            <b-row>
                                <b-col xl="12" lg="12" sm="12">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset" enctype="multipart/form-data">
                                            <b-row>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Organization Name" vid="organization_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="organization_id "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="form_data.org_id"
                                                                id="organization_id"
                                                                :options="orgList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Institute Type" vid="institute_type_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="institute_type "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_config.institute_type')}}  <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="form_data.office_type_id"
                                                                id="institute_type_id"
                                                                :options="officeTypeList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Institute Name" vid="institute_name" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="institute_name "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.institute_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="form_data.office_id"
                                                                id="institute_name"
                                                                :options="officeList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Class" vid="class_id" rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="class_id "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.class')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="form_data.class_id"
                                                                id="class_id"
                                                                :options="classList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Student" vid="student_name" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="student_name "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('ds_student_management.student_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="form_data.student_name"
                                                                id="institute_name"
                                                                :options="studentList"
                                                                @change="GetD(form_data.student_name)"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12" >
                                                    <ValidationProvider name="Contact No" vid='contact_no'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="contact_no"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('ds_institute_management.contact_no')}}
                                                            </template>
                                                            <b-form-input
                                                                id="contact_no"
                                                                disabled
                                                                v-model="form_data.contact_no"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <!-- <b-col xl="6" lg="6" sm="12">
                                                    <ValidationProvider name="Address" vid='address'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="address"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('ds_institute_management.address')}}
                                                            </template>
                                                            <b-form-textarea
                                                                id="address_en"
                                                                disabled
                                                                v-model="form_data.address"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                rows="2"
                                                                max-rows="6"
                                                            ></b-form-textarea>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col> -->
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Date" vid='date' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="date"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('training.date')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                                placeholder="Select Date"
                                                                id="date"
                                                                v-model="form_data.date"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col xl="6" lg="6" sm="12">
                                                    <ValidationProvider name="Reasons (En)" vid='remarks_en' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="remarks_en"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('training.reason_en')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-textarea
                                                                id="address_en"
                                                                v-model="form_data.remarks_en"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                rows="2"
                                                                max-rows="6"
                                                            ></b-form-textarea>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col xl="6" lg="6" sm="12">
                                                    <ValidationProvider name="Reasons (Bn)" vid='remarks_bn' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="remarks_bn"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('training.reason_bn')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-textarea
                                                                id="address_bn"
                                                                v-model="form_data.remarks_bn"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                rows="2"
                                                                max-rows="6"
                                                            ></b-form-textarea>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>

                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                    &nbsp;
                                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import { mapGetters } from 'vuex'
    // import { core } from '../../../../../config/pluginInit'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
    import { StudentDropReleasenAdd, StudentDropReleasenUpdate, studentInfo } from '../../api/routes'
    import flatpickr from 'flatpickr'
    export default {
        props: ['id'],
        components: {
            ValidationObserver,
            ValidationProvider
        },
        created () {
            this.form_data.org_id = this.$store.state.dataFilters.orgId
            this.form_data.office_type_id = this.$store.state.dataFilters.officeTypeId
            this.form_data.office_id = this.$store.state.dataFilters.officeId
            if (this.id) {
                this.institute_id = this.id
                const tmp = this.getInstituteInfoData()
                this.form_data = tmp
                this.form_data.student_roll = tmp.student.student_id
                this.form_data.student_name = tmp.student.name_en
                this.form_data.address = tmp.student.address.address
                this.form_data.contact_no = tmp.student.mobile_no
                this.form_data.class_id = tmp.student.class_name.class_name
                this.form_data.applicant_id = tmp.applicant_id
                this.form_data.date = tmp.date
                this.form_data.remarks_en = tmp.remarks
                this.form_data.remarks_bn = tmp.remarks_bn
            }
        },
        mounted () {
            flatpickr('#date', {})
            // core.index()
        },
        data () {
            return {
                ItemShow: false,
                formLoader: false,
                saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
                disabilitySchoolServiceBaseUrl: disabilitySchoolServiceBaseUrl,
                form_data: {
                    org_id: null,
                    student_id: null,
                    office_type_id: null,
                    office_id: null,
                    institute_code: null,
                    hostel_id: null,
                    student_name: null,
                    applicant_id: null,
                    contact_no: null,
                    class_id: null,
                    address: null,
                    date: null,
                    remarks_en: null,
                    remarks_bn: null
                },
                institute_id: '',
                upload_image: '',
                officeTypeList: [],
                hostelList: [],
                officeList: [],
                studentList: [],
                AllSTudent: [],
                loading: false,
                preview: 'data:image/png;base64,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'
            }
        },
        computed: {
            orgList: function () {
                return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
            },
            currentLocale () {
                return this.$i18n.locale
            },
            classList: function () {
                const list = this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1)
                return list.map(obj => {
                    if (this.currentLocale === 'en') {
                        return { value: obj.value, text: obj.text_en }
                    } else {
                        return { value: obj.value, text: obj.text_bn }
                    }
                })
            },
            ...mapGetters({
                childCommonObj: 'ChildService/commonObj'
            })
        },
        watch: {
            'form_data.org_id': function (newVal) {
                this.officeTypeList = this.getofficeTypeList(newVal)
            },
            'form_data.office_type_id': function (newVal) {
                this.officeList = this.getOfficeList(newVal)
            },
            'form_data.office_id': function (newVal) {
                this.form_data.institute_code = this.getOfficeCode(newVal)
                this.hostelList = this.getHostel(newVal)
                if (this.form_data.class_id) {
                    this.FetchStudent()
                }
            },
            'form_data.class_id': function (newVal) {
               this.FetchStudent()
            }
        },
        methods: {
            GetD (e) {
                const element = this.AllSTudent.find(item => item.value === e)
                this.form_data.address = element.address
                this.form_data.student_id = element.student_id
                this.form_data.contact_no = element.mobile_no
                this.form_data.class = element.class_name
                this.form_data.applicant_id = element.value
            },
            FetchStudent () {
                const data = {
                    office_id: this.form_data.office_id,
                    class_id: this.form_data.class_id
                }
                this.formLoader = true
                RestApi.postData(disabilitySchoolServiceBaseUrl, studentInfo, data).then(response => {
                    const info = []
                    const lng = this.$i18n.locale
                    this.AllSTudent = response.data
                    response.data.forEach(function (element, index) {
                        var t = lng === 'bn' ? element.text_bn : element.text_en
                        info.push({
                            value: element.value,
                            text: t + ' - (Roll: ' + element.student_id + ' / ' + element.mobile_no + ')',
                            item: element
                        })
                    })
                    this.studentList = info
                    this.formLoader = false
                })
            },
            getHostel (id) {
                return this.$store.state.DisabilitySchoolService.commonObj.hostelList.filter(item => item.office_id === id)
            },
            getInstituteInfoData () {
                const tmpData = this.$store.state.list.find(item => item.id === this.institute_id)
                return JSON.parse(JSON.stringify(tmpData))
            },
            async storeUpdate () {
                this.formLoader = true
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                let result = null
                const loadingState = { loading: false, listReload: false }
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                var formData = new FormData()
                Object.keys(this.form_data).map(key => {
                    if (key === 'image') {
                        formData.append(key, this.upload_image)
                    } else {
                        formData.append(key, this.form_data[key])
                    }
                })
                if (this.institute_id) {
                    formData.append('_method', 'PUT')
                    result = await RestApi.postData(disabilitySchoolServiceBaseUrl, `${StudentDropReleasenUpdate}/${this.institute_id}`, formData, config)
                } else {
                    result = await RestApi.postData(disabilitySchoolServiceBaseUrl, StudentDropReleasenAdd, formData, config)
                }
                loadingState.listReload = true
                this.$store.dispatch('mutateCommonProperties', loadingState)
                if (result.success) {
                    this.formLoader = false
                    this.$toast.success({
                        title: this.$t('globalTrans.success'),
                        message: this.institute_id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-4')
                } else {
                    this.$refs.form.setErrors(result.errors)
                }
            },
            getofficeTypeList (orgId = null) {
                const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0)
                if (orgId) {
                    return instituteTypeList.filter(institute => institute.org_id === orgId)
                }

                return instituteTypeList
            },
            getOfficeList (typeId = null) {
                const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
                if (typeId) {
                    return instituteList.filter(institute => institute.office_type_id === typeId)
                }

                return instituteList
            },
            getOfficeCode (Id) {
                const instituteList = this.$store.state.commonObj.officeList.find(item => item.status === 0 && item.value === Id)
                return instituteList.office_code
            }
        }
    }

</script>
